import React from "react";
import PropTypes from "prop-types";
import { Grid } from "@mui/material";
import { useSelector } from "react-redux";

import { formatDateTime } from "../../../../utils/Helpers";
import "../_EventDetailFields.scss";

const DateField = ({ label, value, lang, notProvided }) => (
  <div className="event-detail-highlight-field">
    <span className="event-detail-highlight-label">{label}</span>
    <span className="event-detail-highlight-value">
      {value ? formatDateTime(value, lang) : notProvided}
    </span>
  </div>
);

DateField.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string,
  lang: PropTypes.string.isRequired,
  notProvided: PropTypes.string.isRequired,
};

DateField.defaultProps = {
  value: "",
};

const TimelineSection = ({
  title,
  icon,
  start,
  end,
  tLabels,
  gridItemProps,
}) => {
  const lang = useSelector((state) => state.locale.lang);
  const itemProps = {
    xs: 12,
    sm: 4,
    ...(gridItemProps || {}),
  };

  return (
    <Grid item {...itemProps}>
      <div className="event-detail-section-heading">
        {icon}
        <span>{title}</span>
      </div>
      <div className="event-detail-highlight-box">
        <DateField
          label={tLabels.start}
          value={start}
          lang={lang}
          notProvided={tLabels.notProvided}
        />
        <DateField
          label={tLabels.end}
          value={end}
          lang={lang}
          notProvided={tLabels.notProvided}
        />
      </div>
    </Grid>
  );
};

TimelineSection.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.node.isRequired,
  start: PropTypes.string,
  end: PropTypes.string,
  tLabels: PropTypes.shape({
    start: PropTypes.string.isRequired,
    end: PropTypes.string.isRequired,
    notProvided: PropTypes.string.isRequired,
  }).isRequired,
  gridItemProps: PropTypes.object,
};

TimelineSection.defaultProps = {
  start: "",
  end: "",
  gridItemProps: undefined,
};

export default TimelineSection;
